import React from 'react'
import Smiley from '../Smiley'
import ClickedLink from './ClickedLink'
import { getStarsJSX, reviewLinkSent } from '../redux/FeedbackRedux'

class ReviewSection extends React.Component {

    render() {
        var isReviewLinkSent = reviewLinkSent(this.props.feedback.chats);
        if (this.props.feedback.ratethisbizrating && 'review_text' in this.props.feedback.ratethisbizrating && this.props.feedback.ratethisbizrating.review_text != null) {
            var ratethisbizcomment = <div className="col-md-4"><p>Left A Ratethisbiz Comment: <span className="text-muted">Yes</span></p></div>;
            var ratethisbizreviewtitle = <div className="col-md-12 mt-3" key={0}><p className="mb-0">Comment Left on RateThisBiz.com:</p></div>;
            var ratethisbizreview = <div className="col-md-12" key={1}><p className="text-muted">{this.props.feedback.ratethisbizrating.review_text}</p></div>;
            var ratethisbizreview = [ratethisbizreviewtitle, ratethisbizreview];
        } else {
            var ratethisbizcomment = null;
            var ratethisizreview = null;
        }

        var ratethisbizreached = null;
        if (isReviewLinkSent) {
            if (this.props.feedback.ratethisbizrating && 'created_at' in this.props.feedback.ratethisbizrating) {
                ratethisbizreached = <div className="col-md-4"><p>{__("Feedbacker Clicked Review Link")}: <span className="text-muted">{this.props.feedback.ratethisbizrating.created_at}</span></p></div>;
            } else {
                ratethisbizreached = <div className="col-md-4"><p>{__("Feedbacker Clicked Review Link")}: <span className="text-muted">{__("No")}</span></p></div>;
            }
        }

        var ratethisbizrating = null;
        if (this.props.feedback.ratethisbizrating && 'rating' in this.props.feedback.ratethisbizrating) {
            var stars = "None";
            if (this.props.feedback.ratethisbizrating.is_one_thru_five) {
                stars = getStarsJSX(this.props.feedback.ratethisbizrating.rating, "OTF");
                ratethisbizrating = <div className="col-md-4"><p>{__('Rating Submitted')}: <span style={{ whiteSpace: "nowrap" }}>{stars}</span> <i className="far fa-question-circle text-muted" data-toggle="tooltip" data-placement="top" data-title={"This is the star rating submitted by the customer after receiving the 1Thru5 Link. This is a private site owned by Feedback and this rating is not made public."}></i></p></div>;
            } else if (this.props.feedback.ratethisbizrating.is_ro) {
                stars = getStarsJSX(this.props.feedback.ratethisbizrating.rating, "RO");
                ratethisbizrating = <div className="col-md-4"><p>Closed RO 1thru5 Review: <span style={{ whiteSpace: "nowrap" }}>{stars}</span> <i className="far fa-question-circle text-muted" data-toggle="tooltip" data-placement="top" data-title={"This is the star rating submitted by the customer after receiving the Closed RO Text Link. This is a private site owned by Feedback and this rating is not made public."}></i></p></div>;
            } else {
                stars = getStarsJSX(this.props.feedback.ratethisbizrating.rating);
                ratethisbizrating = <div className="col-md-4"><p>RateThisBiz Review: <span style={{ whiteSpace: "nowrap" }}>{stars}</span> <i className="far fa-question-circle text-muted" data-toggle="tooltip" data-placement="top" data-title={"This is the star rating submitted by the customer after receiving the review request link. This is a private site owned by Feedback and this rating is not made public."}></i></p></div>;
            }
        }

        var ratethisbizlinksent = <div className="col-md-4">
            <p>{__('Rating Request Sent')}: <span className="text-muted" data-toggle="tooltip" data-title={ __('Displays if a rating request to an online review site has been sent to this Feedbacker') }>{isReviewLinkSent ? __('Yes') : __('No')}</span></p>
        </div>;
        var clicked_links = this.props.feedback.smileyclicks.length + this.props.feedback.ratethisbizclicks.length;
        var all_links = this.props.feedback.ratethisbizclicks.concat(this.props.feedback.smileyclicks);

        var all_sites = [];
        var business = this.props.feedback.business;
        var hardcoded_sites = ['link_yelp', 'link_facebook', 'link_google'];
        hardcoded_sites.forEach(function (value) {

            if (business.social_media && business.social_media[value]) {
                try {
                    var url = new URL(business.social_media[value]);
                    all_sites.push(url.hostname);
                } catch (err) {

                }
            }
        });

        this.props.feedback.business.links.forEach(function (value) {
            var url = new URL(value.custom_url);
            all_sites.push(url.hostname);
        });

        var review_link_clicks_description = __('This will let you know if the customer clicked on the public facing sites you have listed on RateThisBiz.com when leaving a 4 or 5 star review.You currently do not have any publicly facing sites listed. Click on the "More" link on the left menu and select "Social Media."');

        if (all_sites.length >= 1) {
            var all_sites_string = all_sites[0];
            if (all_sites.length > 1)
                all_sites_string = all_sites.slice(0, -1).join(', ') + ' and ' + all_sites.slice(-1);

            var review_link_clicks_description = __("This will let you know if the customer clicked on the public facing sites you have listed on RateThisBiz.com when leaving a 4 or 5 star review. You currently have ") + all_sites_string + __('displayed');
        }





        // XXXXX will be the sites they have set up.If none, put:
        //

        var reviewlinksclicked = <div className="col-md-4"><p>{__('Review Links Clicked')}: <span className="text-muted">{(clicked_links > 0 ? clicked_links : "None")}</span> <i className="far fa-question-circle text-muted" data-toggle="tooltip" data-placement="top" data-title={review_link_clicks_description} ></i></p></div>;

        var smileyrating = <div className="col-md-4 col-sm-12 d-flex algin-items-center" style={{ "lineHeight": "20px", "alignItems": "center" }}>{__('Smiley Rating')}:&nbsp;<Smiley is_feedback_detail={true} smiley_score={this.props.feedback.smiley_score} /> <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top" data-title={__('A Feedback\'s smiley rating is chosen by the Feedbacker when they submit the Feedback. The ratings are color-coded as follows unhappiest to happiest:') + ": <img src='/img/feedback-smiley-rating-scale.png' style='width:100%; border-radius: 5px;' />"}></i></div>;
        if (clicked_links > 0) {
            var clickedlinks = <div className="col-md-12 ">
                <div className="row">
                    {all_links.map((value, index) => {
                        return (<ClickedLink key={index} link={value} />);
                    })}
                </div>
            </div>;
        } else {
            var clickedlinks = null;
        }

        if (this.props.feedback.sentiment_score) {
            var AIScore = <div className="col-md-4 col-sm-12" style={{ "lineHeight": "20px" }}>
                {__('AI Sentiment Score')}: <span className={AIScore}> {(this.props.feedback.sentiment_score != 0 ? ((((this.props.feedback.sentiment_score.score + 1) / 2) * 100).toFixed(1) + "%") : "No Data")}
                </span> <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top"
                    data-title={__("AI analysis of verbiage used in the feedback producing a sentiment score on a scale of 1-100")}></i>
            </div>
        } else if (!this.props.feedback.sentiment_score) {
            var AIScore = <div className="col-md-4 col-sm-12" style={{ "lineHeight": "20px" }}>
                {__('AI Sentiment Score')}: <span className={AIScore}>50%</span>
                <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top" data-title={__("AI analysis of verbiage used in the feedback producing a sentiment score on a scale of 1-100")}></i>
            </div>
        } else if (!this.props.feedback.sentiment_score && this.props.feedback.otf_id && !this.props.feedback.description) {
            var AIScore = <div className="col-md-4 col-sm-12" style={{ "lineHeight": "20px" }}>
                {__('AI Sentiment Score')}: <span className={AIScore}>{__('No Feedback Provided')}</span>
                <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top" data-title={__("AI analysis of verbiage used in the feedback producing a sentiment score on a scale of 1-100")}></i>
            </div>
        }

        return (
            <div className="card-body review-status border-bottom satisfaction-metrics">
                <div className="row mb-2">
                    <div className="col-md-auto sol-sm-12">
                        <h4 className="mb-0"><strong>{__('Satisfaction Metrics')}:</strong></h4>
                    </div>
                </div>


                <div className="row detail-list mb-2">
                    {smileyrating}
                    {AIScore}
                </div>
                <div className="row detail-list mb-2">


                    {ratethisbizlinksent}
                    {ratethisbizreached}
                    {ratethisbizrating}
                </div>
                {isReviewLinkSent &&
                    <div className="row detail-list mb-2">
                        {ratethisbizreview}
                        {(clicked_links > 0 || (this.props.feedback.ratethisbizrating && (this.props.feedback.ratethisbizrating.rating >= 4))) && reviewlinksclicked}
                        {clickedlinks}
                    </div>
                }
            </div>
        );
    }

}


export default ReviewSection;
